// extracted by mini-css-extract-plugin
module.exports = {"PlainFeature":"vx_a bgu_b"};